
const CertifiedEngineersSection = () => {
  return (
    <section className="py-20 bg-[#f8f9fa]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            全拠点にDJI認定整備士が在籍
          </h2>
          <p className="text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
            IDS教習所グループの佐賀・川副・鹿児島の全3拠点には、DJIから正式に認定された整備士が在籍しています。DJIの修理マニュアル・アフターサービスポリシーに基づく厳格なトレーニングを受けた整備士が、お客様の大切な機体を丁寧に点検・整備いたします。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white rounded-xl shadow-lg p-8 text-center">
            <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-user-star-line text-4xl text-blue-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              DJI認定整備士
            </h3>
            <p className="text-gray-600 leading-relaxed">
              DJI公式トレーニングを修了した認定整備士が、専門知識と技術で確実な点検・修理を行います。
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 text-center">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-shield-check-line text-4xl text-green-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              品質保証
            </h3>
            <p className="text-gray-600 leading-relaxed">
              DJI純正部品を使用し、メーカー基準に準拠した高品質な修理・整備サービスを提供します。
            </p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-8 text-center">
            <div className="w-20 h-20 bg-purple-100 rounded-full flex items-center justify-center mb-6 mx-auto">
              <i className="ri-tools-line text-4xl text-purple-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-4">
              専門設備
            </h3>
            <p className="text-gray-600 leading-relaxed">
              最新の診断機器と専用工具を完備し、精密な点検・修理作業を実現しています。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertifiedEngineersSection;
